const API_URL = "https://applia-backend.vercel.app/api/data"; // Live backend URL

export async function fetchCountryData() {
	try {
		const response = await fetch(API_URL);
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const json = await response.json();

		return json.table2 ?? [];
	} catch (error) {
		console.error("Error fetching trade data:", error);
		return [];
	}
}